import "./Video.scss";
import { forwardRef } from "react";

interface Props {
  videoUrl: string;
  autoPlay?: boolean;
  muted?: boolean;
  playsInline?: boolean;
  controls?: boolean;
  aspect?: "16/9" | "9/16"; // added prop for aspect ratio
  className?: string; // optional extra class names
  poster?: string;
  preload?: "auto" | "metadata" | "none"; // added preload prop
  disableFullscreen?: boolean;
}

const Video = forwardRef<HTMLVideoElement, Props & { startTime?: number }>(
  (
    {
      videoUrl,
      autoPlay = false,
      muted = false,
      playsInline = false,
      controls = true,
      aspect = "16/9",
      className,
      poster,
      preload = "metadata",
      disableFullscreen = false,
      startTime = 0,
    },
    ref
  ) => {
    return (
      <div
        className={`video-react aspect-${aspect.replace("/", "-")} ${className}`}
      >
        <video
          ref={(videoEl) => {
            if (typeof ref === "function") ref(videoEl);
            else if (ref) (ref as any).current = videoEl;

            if (videoEl) {
              // React's `muted` JSX prop isn't always reflected on initial render, which blocks mobile autoplay. Set it imperatively to be safe.
              videoEl.muted = muted;
              videoEl.addEventListener("loadedmetadata", () => {
                if (startTime > 0 && videoEl.currentTime !== startTime) {
                  videoEl.currentTime = startTime;
                }
              });
            }
          }}
          onLoadedMetadata={(e) => {
            const videoEl = e.currentTarget;
            if (startTime > 0 && videoEl.currentTime !== startTime) {
              videoEl.currentTime = startTime;
            }
          }}
          src={videoUrl}
          autoPlay={autoPlay}
          muted={muted}
          playsInline={playsInline}
          controls={controls}
          controlsList={
            disableFullscreen ? "nofullscreen nodownload" : "nodownload"
          }
          poster={poster}
          preload={preload}
          disablePictureInPicture={disableFullscreen}
        />
      </div>
    );
  }
);
export default Video;
